import React, { useState, useEffect } from "react";

// setCantidad receives (delta, isManual):
//  - stepper buttons send a fixed +/- `intervalo` delta
//  - manual input sends a delta derived from `inputType`:
//      "acumulado"   → typed value is the new running total (delta = typed - current)
//      "diferencial" → typed value is the delta itself
// With permitirExcedente (avance pickers) the total may go over `limite`; the
// excess is an aditiva and the input is highlighted like aditivo conceptos.
const AvancePickerMobile = ({
  limite,
  progreso,
  intervalo,
  setCantidad,
  inputType = "acumulado",
  suffix = "%",
  permitirExcedente = false,
}) => {
  const max = parseFloat(limite);
  const clampTotal = (value) =>
    permitirExcedente || isNaN(max)
      ? Math.max(0, value)
      : Math.max(0, Math.min(max, value));
  // displayProgreso shows the optimistic value immediately, before the
  // backend request resolves and the parent refreshes `progreso`.
  const [displayProgreso, setDisplayProgreso] = useState(progreso);
  const [inputProgreso, setInputProgreso] = useState("");

  useEffect(() => {
    // Parent refreshed with the real value: sync and exit typing mode.
    setDisplayProgreso(progreso);
    setInputProgreso("");
  }, [progreso]);

  const isTyping = inputProgreso !== "";
  const esAditiva =
    permitirExcedente && !isNaN(max) && parseFloat(displayProgreso) > max;

  const handleClick = (step) => {
    const current = parseFloat(displayProgreso);
    const next = clampTotal(current + parseFloat(step));
    const delta = next - current;
    if (!delta) return;
    // Reflect the change immediately so the user isn't tempted to retap.
    setDisplayProgreso(next);
    if (typeof setCantidad === "function") {
      setCantidad(delta, false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const typed = parseFloat(inputProgreso);
    if (isNaN(typed)) {
      setInputProgreso("");
      return;
    }
    const current = parseFloat(progreso);
    // "diferencial": typed value is the delta; "acumulado": it's the new total.
    const target =
      inputType === "diferencial"
        ? current + typed
        : typed;
    // Validate: resulting total non-negative (and not over the limit unless
    // excess is allowed).
    const nextTotal = clampTotal(target);
    const delta = nextTotal - current;
    setDisplayProgreso(nextTotal);
    setInputProgreso(""); // back to stepper mode
    if (typeof setCantidad === "function" && delta) {
      setCantidad(delta, true);
    }
  };

  return (
    <div className="avance-picker">
      <div className="input-group input-group-sm flex-nowrap">
        {!isTyping && (
          <button
            type="button"
            className="btn btn-light border-0 px-2"
            disabled={parseFloat(displayProgreso) <= 0}
            onClick={() => handleClick(parseFloat(intervalo) * -1)}
          >
            -
          </button>
        )}
        <input
          type="number"
          min={0}
          max={permitirExcedente ? undefined : max}
          value={inputProgreso}
          placeholder={`${displayProgreso} ${suffix}`.trim()}
          title={esAditiva ? "Aditiva: excede el 100%" : undefined}
          className={`form-control border-0 border-start border-end rounded-0 text-center px-1 ${
            esAditiva ? "concepto-aditivo" : ""
          }`}
          onChange={(e) => setInputProgreso(e.target.value)}
        />
        {isTyping ? (
          <button className="btn btn-primary rounded-0 px-2" onClick={handleSubmit}>
            <i className="fa fa-save"></i>
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-light border-0 px-2"
            disabled={!permitirExcedente && parseFloat(displayProgreso) >= max}
            onClick={() => handleClick(parseFloat(intervalo))}
          >
            +
          </button>
        )}
      </div>
    </div>
  );
};

export default AvancePickerMobile;
